import { getRequest, putRequest, postRequest } from "../system/server-call";
import responseHandler from "../system/server-response-handler";
import { globalConstants } from "../constants";

//Get all instructors of center
const getCenterInstructors = (centerId, params) => {
  return postRequest(
    `/${globalConstants.VERSION}/Instructor/center/${centerId}`,
    params
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get instructor details by email
const getInstructorByEmail = (email) => {
  return postRequest(
    `/${globalConstants.VERSION}/Instructor/centerInstructor`,
    email,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Add center instructor
const addCenterInstructor = (centerId, instructorId) => {
  return putRequest(
    `/${globalConstants.VERSION}/Instructor/add/${centerId}/${instructorId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const removeCenterInstructor = (centerId, instructorId) => {
  return putRequest(
    `/${globalConstants.VERSION}/Instructor/remove/${instructorId}/${centerId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const removeCenterInstructorByAdmin = (centerId, instructorId) => {
  return putRequest(
    `/${globalConstants.VERSION}/admin/Instructor/remove/${instructorId}/${centerId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const approveRejectCenterInstructorRequest = (isApproved, instructorId) => {
  return putRequest(
    `/${globalConstants.VERSION}/Instructor/approval/${isApproved}/${instructorId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

//Get center instructor details by id
const getCenterInstructorDetailById = (id, centerId) => {
  return getRequest(
    `/${globalConstants.VERSION}/Instructor/center/instructor/${id}?centerId=${centerId}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const centerInstructorsService = {
  getInstructorByEmail,
  addCenterInstructor,
  getCenterInstructors,
  removeCenterInstructor,
  getCenterInstructorDetailById,
  removeCenterInstructorByAdmin,
  approveRejectCenterInstructorRequest,
};
